import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import SliderPicklistControl from 'Components/ComponentLibrary/Components/Inputs/Picklist/SliderPicklistControl';

export default fr.metaOverride({ base: BaseOverride })
  .typeOverride('picklist', {
    _component: () => SliderPicklistControl,
  });
